export default "__VITE_ASSET__DhQDqiP7__"